import { Component, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  UntypedFormBuilder,
  Validator,
  Validators
} from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { ShippingInformation } from '@queries/generated';

@UntilDestroy()
@Component({
  selector: 'vnm-shipping-information-form',
  templateUrl: './shipping-information-form.component.html',
  styleUrls: ['./shipping-information-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ShippingInformationFormComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ShippingInformationFormComponent),
      multi: true
    }
  ]
})
export class ShippingInformationFormComponent implements ControlValueAccessor, Validator {
  shippingInfoForm = this.fb.group({
    name: [null, Validators.required],
    companyName: [null],
    phoneNumber: [null, [Validators.required, Validators.pattern(/\(\d{3}\)\s(?:\d{3}-\d{4})|\d{10}/)]],
    email: [null, [Validators.required, Validators.email]]
  });

  constructor(private fb: UntypedFormBuilder) {}

  onChange: any = () => {};
  onTouched: any = () => {};

  registerOnChange(fn: () => void) {
    this.shippingInfoForm.valueChanges.pipe(untilDestroyed(this)).subscribe(fn);
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  writeValue(value: ShippingInformation) {
    this.shippingInfoForm.patchValue(value);
    this.shippingInfoForm.updateValueAndValidity();
  }

  validate() {
    return this.shippingInfoForm.valid ? null : { shippingInformation: { valid: false, message: 'Fields required.' } };
  }
}
